import { NavigateFunction } from "react-router-dom";
import axiosClient from "../axioxClient.ts/axiosClient";
// import { dynamicFailed } from "../hooks/useToast";

export const tryRefreshToken = async (navigate: NavigateFunction) => {
  try {
    const res = await axiosClient.post<any>("/auth/refresh");
    const newAccessToken = res.data.access_token;
    return newAccessToken;
  } catch (err) {
    // dynamicFailed("User must login again!");
    navigate("/login");
  }
};
